import { render, staticRenderFns } from "./GameSummary.vue?vue&type=template&id=7a8ba909"
import script from "./GameSummary.vue?vue&type=script&lang=js"
export * from "./GameSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports